import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {fetchBaseFPNetQuery} from "../../../utils/fetchBaseFPNetQuery";
import {addURI, transformResponse} from "@commons/utils/APIParams";
import {config} from "@commons/config.instance";
import {PVAFormData} from "@commons/mapping/PVAFormData";

export interface Params {
    idAziendaMaster: number | null,
}

export const PVAFilterApi = createApi({
    reducerPath: 'PVAFilterApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('FPNet')}),
    endpoints: (builder) => ({

        getFilter: builder.query<PVAFormData, Params>({
            query: ({idAziendaMaster}) => {
                let params: string[] = [];
                //https://fpnet2.ericed.it/FPNet2021/PVA/azienda/2353-2353/dashboard/piano/298/teste?auth_token=436e41f987a48db91a2247526b5dbeae&nowId=1675785942749
                //https://fpnet2.ericed.it/FPNet2021/PVA/azienda/2353/dashboard/filter?auth_token=436e41f987a48db91a2247526b5dbeae&nowId=1675786605921
                return `/PVA/azienda/${idAziendaMaster}/dashboard/filter?${params.length > 0 ? '&' + encodeURI(params.join("&")) : ''}`;
            },
            transformResponse: addURI
        }),
        updateFilter: builder.mutation<Partial<PVAFormData>, Partial<PVAFormData>>({
            // note: an optional `queryFn` may be used in place of `query`
            query: ({idAziendaMaster, ...patch}) => ({
                url: `/PVA/azienda/${idAziendaMaster}/dashboard/filter`,
                method: 'PATCH',
                body: patch,
            }),
            transformResponse,
            //invalidatesTags: (result, error, {URI}) => [{type: 'Lavoratori', URI}],
        }),
    }),
})
export const {
    useGetFilterQuery,
    useUpdateFilterMutation,
} = PVAFilterApi;